import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { CUSTOMER_SUPPORT, VIEWER } from "../Util/user-types-constant";
import { lastInstallationStorageKey, parseContextFromPath } from "../helper/url-builder";

function useUser() {
    const authUser = useSelector((state) => state.authUser);
    const urlParams = useParams();
    const { pathname } = useLocation();

    return useMemo(() => {
        const users = authUser.users;
        const activeUser = users[0];
        const pathCtx = parseContextFromPath(pathname || '');

        return {
            authUser,
            getActiveUser: () => activeUser,
            getParentUser: () => (users.length > 1 ? users[1] : null),
            getUserInstallationId: () => {
                if (urlParams.installationId != null && String(urlParams.installationId) !== '') {
                    return String(urlParams.installationId);
                }
                if (pathCtx.installationId) {
                    return String(pathCtx.installationId);
                }
                const fromInstallation =
                    activeUser?.installation?.id ??
                    activeUser?.installation?.installationId ??
                    activeUser?.installationId;
                if (fromInstallation != null && String(fromInstallation) !== '') {
                    return String(fromInstallation);
                }
                const companyKey =
                    urlParams.companyId?.toString() ||
                    pathCtx.companyId ||
                    activeUser?.companyId?.toString() ||
                    '';
                if (companyKey && typeof sessionStorage !== 'undefined') {
                    const storageKey = lastInstallationStorageKey(companyKey);
                    if (storageKey) {
                        const stored = sessionStorage.getItem(storageKey) || '';
                        if (stored && stored !== '0') {
                            return stored;
                        }
                    }
                }
                return null;
            },
            getUserInstallationCode: () => activeUser?.installation?.installationCode || null,
            getUserTimeZone: () => activeUser?.timezone,
            getToken: () => authUser.token,
            getRegionId: () => activeUser?.regionId,
            getCompanyType: () => activeUser?.companyType,
            getInstallationPrefix: () => activeUser?.installationPrefix || "",
            getCompanyId: () => {
                if (urlParams.companyId != null && String(urlParams.companyId) !== '') {
                    return String(urlParams.companyId);
                }
                if (pathCtx.companyId) {
                    return String(pathCtx.companyId);
                }
                return activeUser?.companyId?.toString() || "";
            },
            getUserInstallationInfo: () => activeUser?.installation || {},
            getUserBillingStatus: () => activeUser?.billingEnabled,
            getUserList: () => users || [],
            getUserRole: () => authUser?.role || "",
            userCURDPermission: () => authUser?.role !== CUSTOMER_SUPPORT && authUser?.role !== VIEWER,
            getLoginCompany: () => users[users.length - 1],
        };
    }, [authUser, urlParams, pathname]);
}

export default useUser;
